import React, { useEffect } from 'react';
import { ImageItemCont, ImageElement } from './MediaItem.styles';

interface Props {
  src: string;
  setPortrait: VoidFunction;
}

const ImageItem: React.FC<Props> = ({ src, setPortrait }) => {
  useEffect(() => {
    const i: HTMLImageElement = new Image();

    i.onload = function () {
      if (i.width < i.height) setPortrait();
    };

    i.src = src;
  }, [src]);

  return (
    <ImageItemCont>
      <ImageElement src={`${src}/214x0`} />
    </ImageItemCont>
  );
};

export default ImageItem;
